import { Theme } from '@mui/material/styles'

const muiAvatarGroup = (theme: Theme) => {
  return {
    styleOverrides: {
      avatar: {
        border: `1px solid ${theme.palette.primary.contrastText}`,
        fontSize: '1rem'
      }
    }
  }
}

export default muiAvatarGroup
